<immo-header>
  <!-- LEFT -->
  <div ngProjectAs="immo-header-left" class="shrink-0 flex items-center gap-3">
    <a
      [routerLink]="''"
      immoIconButton
      icon="ambos-immo"
      size="lg"
      outlined
      theme="primary-inverse"
    ></a>
    <!-- <mat-icon svgIcon="ambos-immo" class="size-8!" /> -->
  </div>
  <!-- /left -->
  <immo-header-navigation [navigation]="navigation()" />
  <ng-container ngProjectAs="immo-header-right">
    <backoffice-property-select [label]="''" class="w-64 shrink-0" />
    <button
      type="button"
      immoIconButton
      icon="chat-circle-dots"
      size="md"
      outlined
      theme="surface-container-low"
      class="shrink-0"
      [title]="'Assistant.Title' | translate"
      (click)="openAssistant()"
    ></button>
    <immo-notification-panel class="shrink-0" [notifications]="notificationItems()"
      (notificationSelected)="openNotification($event)"
      (markAllRead)="markAllNotificationsRead()"
      (viewAllRequested)="viewAllNotifications()" />
    <immo-profile-menu class="shrink-0">
      <ng-container ngProjectAs="immo-profile-menu-header">
        <span class="font-medium">
          {{ user()?.fullName }}
        </span>
        <a class="underline font-light" [href]="`mailto:${user()?.email}`">
          {{ user()?.email }}
        </a>
        <div class="flex gap-3 flex-wrap justify-end items-center">
          <immo-language-picker class="shrink-0" size="xs" outlined />
          <immo-theme-picker class="shrink-0" size="xs" outlined />
        </div>
      </ng-container>
    </immo-profile-menu>
  </ng-container>
</immo-header>
